import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { OfferSelectionCardModel } from '@flocasts/experience-service-types'
import { combineLatest, map } from 'rxjs'
import { SiteIds } from 'src/app/shared/models/site.model'
import { ProductService } from 'src/app/shared/services/product.service'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { VerticalService } from 'src/app/singleton-services/vertical.service'

@Component({
  selector: 'flo-offer-selection-card',
  templateUrl: './offer-selection-card.component.html',
  styleUrls: ['./offer-selection-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OfferSelectionCardComponent {
  constructor(private readonly productService: ProductService, private readonly verticalService: VerticalService) {}
  /**
   * Card displaying offer pricing information
   */
  @Input()
  offer: OfferSelectionCardModel

  /**
   * Indicates if the offer is selected by the user
   */
  @Input()
  isSelected = false

  @Input()
  displayProduct = false

  readonly trackById = trackById

  get isMonthly() {
    return this.offer.heading === 'Monthly Plan'
  }

  public isWrestlingPromoActive$ = combineLatest([
    this.productService.isWrestlingGiftPromoActive$,
    this.verticalService.siteId$
  ]).pipe(
    map(([isWrestlingGiftPromoActive, siteId]) => {
      return isWrestlingGiftPromoActive && siteId === SiteIds.FLOWRESTLING
    })
  )
}
